import { useSyncExternalStore } from 'react';
import {
  DEFAULT_IMAGE_QUALITY_TIER,
  IMAGE_QUALITY_CHANGE_EVENT,
  IMAGE_QUALITY_TIER_OPTIONS,
  getStoredImageQualityTier,
  setStoredImageQualityTier,
} from '../constants/imageQualityTiers';
import {
  IMAGE_PROVIDER_CHANGE_EVENT,
  getCurrentImageProvider,
  getWanxCompatibleQualityOptions,
  normalizeWanxImageQualityTier,
} from '../utils/wanxImageCapabilities';

const subscribeImageSettings = (notify) => {
  window.addEventListener('storage', notify);
  window.addEventListener(IMAGE_PROVIDER_CHANGE_EVENT, notify);
  window.addEventListener(IMAGE_QUALITY_CHANGE_EVENT, notify);
  return () => {
    window.removeEventListener('storage', notify);
    window.removeEventListener(IMAGE_PROVIDER_CHANGE_EVENT, notify);
    window.removeEventListener(IMAGE_QUALITY_CHANGE_EVENT, notify);
  };
};

const getServerProvider = () => 'wangsugem';
const getServerQuality = () => DEFAULT_IMAGE_QUALITY_TIER;

export const useWorkshopImageSettings = () => {
  const imageProvider = useSyncExternalStore(subscribeImageSettings, getCurrentImageProvider, getServerProvider);
  const preferredQualityTier = useSyncExternalStore(subscribeImageSettings, getStoredImageQualityTier, getServerQuality);
  // 模型限制只影响当前有效档位；切回支持高分辨率的模型时恢复用户原来的选择。
  const imageQualityTier = normalizeWanxImageQualityTier(preferredQualityTier, imageProvider);
  const availableImageQualityTierOptions = getWanxCompatibleQualityOptions(IMAGE_QUALITY_TIER_OPTIONS, imageProvider);

  const handleImageQualityTierChange = (value) => {
    setStoredImageQualityTier(normalizeWanxImageQualityTier(value, getCurrentImageProvider()));
  };

  return { imageProvider, imageQualityTier, availableImageQualityTierOptions, handleImageQualityTierChange };
};
